export const volumes = [
  {
    numeral: "I",
    title: "The Gastrointestinal Physiology & Digestion Guide",
    tagline: "Build a structured foundation for understanding digestive function and its relationship to nutritional health.",
    body: [
      "Understanding gastrointestinal physiology provides important context for studying nutrition, digestion, and nutrient absorption.",
      "In this volume, I've organized educational references covering the digestive system, gastrointestinal function, digestive processes, and the physiological concepts that influence nutritional considerations.",
    ],
    explore: [
      "Overview of gastrointestinal anatomy",
      "Functions of the major digestive organs",
      "Digestion of carbohydrates, proteins, and fats",
      "Nutrient absorption fundamentals",
      "Gastrointestinal motility concepts",
      "Digestive secretions and their functions",
      "Overview of the intestinal barrier",
      "Fundamentals of the gut microbiome",
      "Relationships between digestive function and nutritional status",
      "Gastrointestinal physiology diagrams and reference summaries",
    ],
    note: "This volume provides foundational educational material to help you organize your understanding of digestion and its relationship to nutrition.",
  },
  {
    numeral: "II",
    title: "The GI Nutrition Assessment Blueprint",
    tagline: "Organize the key elements involved in studying nutritional status in gastrointestinal conditions.",
    body: [
      "Gastrointestinal nutrition assessment involves considering multiple sources of information.",
      "Dietary intake, symptom history, weight trends, nutritional history, relevant laboratory findings, and individual circumstances may all contribute to a broader understanding of nutritional status.",
      "In this volume, I've brought together educational frameworks designed to help you study these assessment components in a more structured way.",
    ],
    explore: [
      "Gastrointestinal nutrition assessment fundamentals",
      "Dietary history review frameworks",
      "Food and symptom documentation concepts",
      "Anthropometric assessment principles",
      "Weight trends and nutritional risk considerations",
      "Relevant laboratory markers and their limitations",
      "Dietary intake documentation worksheets",
      "Malnutrition screening educational concepts",
      "Nutrition-focused assessment frameworks",
      "Structured assessment case exercises",
    ],
    note: "These resources support educational review and do not replace comprehensive clinical assessment or validated assessment methods.",
  },
  {
    numeral: "III",
    title: "The Gastrointestinal Nutrition & Dietary Reference Guide",
    tagline: "Study the nutritional considerations that frequently arise in gastrointestinal nutrition practice.",
    body: [
      "Gastrointestinal nutrition involves more than memorizing lists of foods to eat or avoid.",
      "Nutritional considerations can vary according to the condition, symptoms, nutritional status, treatment, individual tolerance, and other clinical circumstances.",
      "This volume organizes educational references covering major nutrient-related concepts and the considerations professionals study when evaluating gastrointestinal nutrition.",
    ],
    explore: [
      "Dietary fiber and gastrointestinal function",
      "Carbohydrate digestion and absorption",
      "Protein and fat digestion fundamentals",
      "Food composition and nutrient sources",
      "Food label interpretation exercises",
      "Food-related symptom documentation concepts",
      "Overview of lactose digestion and intolerance",
      "Introduction to FODMAP concepts",
      "Nutrient comparison tables",
      "Educational references on dietary patterns and food selection",
    ],
    note: "This volume provides educational information rather than a universal gastrointestinal diet. Dietary recommendations must be individualized and supported by current evidence.",
  },
  {
    numeral: "IV",
    title: "The GI Nutrition Care Planning Workbook",
    tagline: "Organize the educational considerations involved in gastrointestinal nutrition care planning.",
    body: [
      "Developing an appropriate nutrition care plan involves bringing together assessment findings, nutritional priorities, individual circumstances, and relevant clinical guidance.",
      "I designed this volume to help you organize these considerations through structured educational worksheets and case-based exercises.",
    ],
    explore: [
      "Nutrition care planning fundamentals",
      "Nutrition problem identification frameworks",
      "Nutrition diagnosis educational examples",
      "Individualized nutrition goal-setting worksheets",
      "Dietary intervention planning considerations",
      "Nutrition counseling preparation templates",
      "Patient education planning frameworks",
      "Monitoring and evaluation concepts",
      "Nutrition care process documentation worksheets",
      "Hypothetical gastrointestinal nutrition case exercises",
    ],
    note: "These resources support educational planning and professional discussion. They do not generate individualized treatment prescriptions or replace qualified clinical decision-making.",
  },
  {
    numeral: "V",
    title: "The Gastrointestinal Nutrition Clinical Case Analysis Guide",
    tagline: "Develop a more structured approach to studying complex gastrointestinal nutrition scenarios.",
    body: [
      "Gastrointestinal nutrition cases often involve overlapping clinical and nutritional considerations.",
      "Understanding how these factors interact requires more than reviewing isolated facts. It involves organizing the available information, identifying relevant questions, and evaluating the case within its appropriate clinical context.",
      "This volume brings together hypothetical educational scenarios and structured case-review frameworks.",
    ],
    explore: [
      "Irritable bowel syndrome educational cases",
      "Gastrointestinal symptom assessment scenarios",
      "Inflammatory bowel disease nutrition education cases",
      "Malabsorption-related educational scenarios",
      "Nutritional risk identification exercises",
      "Dietary history analysis",
      "Clinical information review frameworks",
      "Structured case discussion worksheets",
      "Nutrition assessment analysis exercises",
      "Educational case synthesis templates",
    ],
    note: "The cases are educational examples designed to support learning. They are not validated treatment protocols or individualized medical recommendations.",
  },
  {
    numeral: "VI",
    title: "The GI Nutrition Documentation & Reference Organization Guide",
    tagline: "Bring greater structure to your educational documentation, reference materials, and professional learning.",
    body: [
      "Nutrition assessment and care planning involve information that may need to be reviewed over time.",
      "Dietary intake, nutritional status, relevant laboratory findings, educational case notes, and follow-up observations can all form part of the professional documentation process.",
      "In this volume, I've organized educational resources designed to help you study documentation practices and maintain a more accessible reference system.",
    ],
    explore: [
      "Gastrointestinal nutrition consultation preparation templates",
      "Dietary assessment documentation frameworks",
      "Nutrition care plan record templates",
      "Nutritional status monitoring worksheets",
      "Weight trend documentation forms",
      "Dietary intake follow-up forms",
      "Nutrition counseling preparation templates",
      "Reference organization matrices",
      "Follow-up assessment worksheets",
      "Educational case review documentation",
    ],
    note: "All templates should be adapted to your professional scope, local documentation requirements, privacy obligations, and applicable clinical standards.",
  },
];
